const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M23 2H1v20h22V2Zm-9.5 18.5h-11l7.5-17h4l7.5 17H17l-5-11L9 17h3l1.5 3.5Z" clip-rule="evenodd"></path></svg>';
export {
  l as default
};
